'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useAppDispatch } from '@/store/hooks';
import { fetchAlertasIntegracoes } from '../store/saudeIntegracoes';
const POLL_INTERVAL_MS = 5 * 60 * 1000;
export function useIntegracaoAlertasPolling() {
  const $ = _c(3);
  const dispatch = useAppDispatch();
  let t0;
  let t1;
  if ($[0] !== dispatch) {
    t0 = () => {
      dispatch(fetchAlertasIntegracoes());
      const id = setInterval(() => {
        dispatch(fetchAlertasIntegracoes());
      }, POLL_INTERVAL_MS);
      return () => clearInterval(id);
    };
    t1 = [dispatch];
    $[0] = dispatch;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}